import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ContextLibraryUploadedFileTypePage } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import { buildQueryKey } from 'utils/buildQueryKey';
import clientUtil from 'utils/clientUtil';

type TVariables = object;
type TData = number;

const MOCK: TVariables = {};

export const useContextLibraryNodesCount = (
  variables: TVariables = MOCK,
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query contextLibraryUploadedFiles {
      contextLibraryUploadedFiles {
        nodesCount
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['useContextLibraryNodesCount', ...buildQueryKey({ ...MOCK, ...variables })],
    queryFn: async () => {
      const response: Pick<ContextLibraryUploadedFileTypePage, 'nodesCount'> = await client.request(
        {
          data: {
            gql: graphql,
            variables
          }
        }
      );

      return response.nodesCount ?? 0;
    }
  });
};
